export const tableMinWidth = (key: string): string => {

  switch (key) {
    case 'user_code':
      return 'min-w-[91px]';
    case 'actions':
      return 'min-w-[92px]'
    case 'created_date':
    case 'last_logged_in':
      return 'min-w-[165px]'
    case 'phone_number':
      return 'min-w-[170px]'
    case 'email_address':
      return 'min-w-[250px]'
    case 'status':
      return 'min-w-[120px]';
    case 'user_location':
      return 'min-w-[200px]';
    case 'user_name':
      return 'min-w-[129px]'
    case 'name':
      return 'min-w-[300px]'
    case 'contract_start_date':
    case 'contract_end_date':
      return 'min-w-[203px]'
    default:
      return 'min-w-[200px]'; // You can return a default value if needed
  }
};

export interface TableDetailsItem {
  sort?: boolean;
  id?: string;
  toggle?: boolean;
  custom?: string[];
  className?: string; // Optional property for custom classes
  actionTypes?: string[]; // Optional property for actions
  actionTypeAction?: { [key: string]: () => void }; // Optional property for action functions
}
